<template>
  <el-radio-group
    v-if="radioView && isDesktop"
    v-model="value"
    class="desktop"
    :disabled="disabled"
    :size="size"
    @update:modelValue="update"
  >
    <el-radio-button v-if="withEmpty" key="all" :value="0">
      All types
    </el-radio-button>
    <el-radio-button
      v-for="adTypeLabel in adTypes"
      :key="adTypeLabel.type_id || adTypeLabel.id"
      :value="adTypeLabel.type_id || adTypeLabel.id"
    >
      <template v-if="onlyIcons && adTypeLabel.icon">
        <img :src="adTypeLabel.icon" :title="adTypeLabel.label" :width="30" />
      </template>
      <template v-else>
        {{ adTypeLabel.label }}
      </template>
    </el-radio-button>
  </el-radio-group>
  <el-select
    v-else
    v-model="value"
    :size="size"
    :placeholder="label"
    :disabled="disabled"
    :multiple="multiple"
    @update:modelValue="update"
  >
    <el-option v-if="withEmpty" key="all" label="All types" :value="0">
      All types
    </el-option>
    <el-option
      v-for="adTypeLabel in adTypes"
      :key="adTypeLabel.type_id || adTypeLabel.id"
      :label="adTypeLabel.label"
      :value="adTypeLabel.type_id || adTypeLabel.id"
    >
      {{ adTypeLabel.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import { DspAdTypeLabels, SspAdTypeLabels } from '@/api/types'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'AdTypeSelect',
  props: {
    label: {
      type: String,
      default: 'Select Ad type'
    },
    modelValue: {
      type: [Number, Array],
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    withEmpty: {
      type: Boolean,
      default: false
    },
    radioView: {
      type: Boolean,
      default: false
    },
    onlyIcons: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    ssp: {
      type: Boolean,
      default: false
    },
    allowedTypes: {
      type: Array,
      default: () => []
    },
    size: {
      type: String,
      default: 'default'
    },
    lables: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const update = (newValue: any) => {
      if (props.multiple) {
        context.emit(
          'update:modelValue',
          newValue.map((x: any) => parseInt(x))
        )
        context.emit('change')
      } else {
        if (newValue !== null) {
          newValue = parseInt(newValue)
        }
        context.emit('update:modelValue', newValue)
        context.emit('change')
      }
    }

    const { isDesktop } = useResize()

    const lables = computed(() => {
      return props.lables.length > 0
        ? props.lables
        : props.ssp
          ? SspAdTypeLabels
          : DspAdTypeLabels
    })

    const adTypes = computed(() => {
      if (props.allowedTypes.length > 0) {
        return lables.value.flatMap((adType: any) => {
          return props.allowedTypes.includes(adType.type_id) ? adType : []
        })
      } else {
        return lables.value
      }
    })

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, adTypes, isDesktop, value }
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-radio-button__orig-radio:checked + .el-radio-button__inner) {
  box-shadow: none;
  background-color: #eceef5;
  border-color: #dddfe6;
  color: #303133;
}

:deep(.el-radio-button__inner:hover) {
  color: #303133;
  background-color: #f5f8fd;
}
</style>
